import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import useStyles from './styles';

const RadioIcon = ({ checked, children }) => {
    const classes = useStyles(checked);
    return <Typography className={classes.radio}>{children}</Typography>;
};

RadioIcon.defaultProps = {
    checked: false
};

RadioIcon.propTypes = {
    checked: PropTypes.bool,
    children: PropTypes.string.isRequired
};

export default RadioIcon;
